import React from 'react';
import '../less/index.less';
import DownloadApp from '../../../../Cards/views/downloadApp.c';
import Order from '../../../../Cards/views/orderAction';
import UsageBlock from "../../../../../auxiliary-components/shared/UsageBlock";
import TextAboveFooter from "../../../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import usage_block_2_data from '../enums/usage_block_2_data.json';
import HowToBlock from "../../../../../auxiliary-components/shared/HowToBlock";
import how_to_installment_1 from "../img/how_to_installment_1.png";
import how_to_installment_2 from "../img/how_to_installment_2.png";
import how_to_installment_3 from "../img/how_to_installment_3.png";
import FilesForDownload from "../../../../../auxiliary-components/shared/FilesForDownload/views/file.c";
import InstallmentCalc from "../components/installmentCalc";
import SliderComponent from "../../../../../auxiliary-components/shared/Slider";
import { Preloader } from "MWComponents";
import order_green_card from "../../../../GreenCard/img/odrer_green_card.png";
import arrow_1 from "../img/arrow_1.png";
import arrow_2 from "../img/arrow_2.png";
import Tooltip from "../../../../../auxiliary-components/shared/Tooltip";

export default function template() {
    const isMobile = this.isViewportMobile(),
      {viewport} = this.props,
      page = 'profit-card',
      howToItems_installment = [
        { img: how_to_installment_1, title: 'MONEY_AUTO_HOW_TO_TITLE_1', text: 'MONEY_AUTO_HOW_TO_INSTALLMENT_TEXT_1' },
        { img: how_to_installment_2, title: 'MONEY_AUTO_HOW_TO_TITLE_2', text: 'MONEY_AUTO_HOW_TO_INSTALLMENT_TEXT_2' },
        { img: how_to_installment_3, title: 'MONEY_AUTO_HOW_TO_TITLE_3', text: 'MONEY_AUTO_HOW_TO_INSTALLMENT_TEXT_3' },
      ],


        model = this.getModel();

    if (model.setRealRate) {
        model.setRealRate(this.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE_1'));
    }

    const orderCards = (
        <div className="card-order-wrapper" id='order'>
            <div className="left-side">
                <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
                <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
                <div className="card-order">
                    <div className="order-wrapper green-card">
                        <Order
                          {...this.props}
                          row={!this.isViewportMobile()}
                          utmParams={this.utmParams}
                          type="green"
                        />
                    </div>
                </div>
            </div>
            <img className="order-img" alt=" " src={order_green_card}></img>
        </div>
    ),
      installmentCalc = (
        <InstallmentCalc></InstallmentCalc>
      ),
      isUtm = this.props.location.search.indexOf('utm_') !== -1,
    app = isMobile && isUtm ?
      (
        <div className="content">
          {orderCards}
        </div>
      )
      :
      (
        <div className="download-app-wrapper" id='order'>
          <DownloadApp {...this.props} />
        </div>
      ),

      usage_img = (
        <img className='usage-arrow' src={isMobile ? arrow_2 : arrow_1} alt="usage_arrow" />
      ),
      tooltip = this.state.tooltipDisplay ?
        (
          <Tooltip element={this.state.tooltipElement} display={this.state.tooltipDisplay ? 'flex' : 'none'}>
            <div className="tooltip-content">{this.l10n("MONEY_AUTO_USAGE_TOOLTIP_TEXT")}</div>
          </Tooltip>
        ) : '';
    return (
      <div className="money-auto-block">
        <div className="slider-container">
          {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile}
                                                                          widget={this.widgetsHelper.getWidget.call(this, "main_banner")}></SliderComponent>}
        </div>
        <div className="content">
          <div className="usage-block-wrapper">
            <UsageBlock isMobile={isMobile} children={usage_img} page={"money-auto"} data={usage_block_2_data} className="col-3-row-1" />
            {tooltip}
          </div>
          <div className="how-to-block-wrapper">
            <div className="block-title">{this.l10n("MONEY_AUTO_HOW_TO_INSTALLMENT_TITLE")}</div>
            <HowToBlock data={howToItems_installment} isMobile={isMobile} page={"shoping-atb"}></HowToBlock>
          </div>
          {isMobile ? app : orderCards}
        </div>
          {installmentCalc}
        <div className="content">
          <FilesForDownload lang={this.props.lang}
                            widget={this.widgetsHelper.getWidget.call(this, "files_to_download")} />
          <div className={`disclaimer-wrapper`}>
            <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, "text_above_footer")}
                             isMobile={isMobile}></TextAboveFooter>
          </div>
        </div>
      </div>

    );
}
